<template>
  <div class="organization-details">
    <v-row align="center">
      <v-col>
        <v-breadcrumbs :items="breadcrumb" large></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-tabs v-model="tab" background-color="primary" dark icons-and-text grow>
      <v-tab href="#tab-settings">
        <span class="mt-2">Settings</span>
        <v-icon>settings</v-icon>
      </v-tab>
      <v-tab-item value="tab-settings" class="grey lighten-5">
        <OrganizationSettings :organization="organization" />
      </v-tab-item>
      <v-tab href="#tab-locations">
        <span class="mt-2">Locations</span>
        <v-icon>location_on</v-icon>
      </v-tab>
      <v-tab-item value="tab-locations" class="grey lighten-5">
        <OrganizationLocations />
      </v-tab-item>
      <v-tab href="#tab-concepts">
        <span class="mt-2">Concepts</span>
        <v-icon>fastfood</v-icon>
      </v-tab>
      <v-tab-item value="tab-concepts" class="grey lighten-5">
        <OrganizationConcepts />
      </v-tab-item>
    </v-tabs>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";

import OrganizationSettings from "./OrganizationSettings";
import OrganizationLocations from "./OrganizationLocations";
import OrganizationConcepts from "./OrganizationConcepts";

export default {
  components: {
    OrganizationConcepts,
    OrganizationSettings,
    OrganizationLocations
  },
  mixins: [mixin],
  data() {
    return {
      organizationUuid: this.$route.params.organizationId,
      organization: {},
      snackbar: false,
      errorMessage: "",
      tab: null
    };
  },
  computed: {
    ...mapState({
      fetchLoading: state => state.organizations.fetchOne.pending,
      fetchError: state => state.organizations.fetchOne.error
    }),
    breadcrumb() {
      return [
        {
          text: "Organizations",
          disabled: false,
          href: "#/admin/organizations"
        },
        {
          text: this.organization ? this.organization.name : "unknown",
          disabled: true
        }
      ];
    }
  },
  methods: {
    ...mapActions("organizations", {
      fetchOne: "fetchOne"
    }),
    refresh() {
      this.fetchOne({ organizationUuid: this.organizationUuid })
        .then(organization => {
          this.organization = organization;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.refresh();
  }
};
</script>

<style>
</style>